import { UserClaim } from "@crimsontide/core/client/user-permissions/interfaces";
import { productFruits } from 'product-fruits';

const initProductFruits = async () => {
  await (window as any).Mpro.UserService.UserPermissionService.ready();
  const permissions: UserClaim[] = await (window as any).Mpro.UserService.UserPermissionService.getUserClaims();

  productFruits.init('w99NjyZBfbqUTTSo', permissions.find((p) => p.type === 'locale')?.value?.slice(0,2) || 'en', {
    username: permissions.find((p) => p.type === 'name')?.value || 'anon',
    role: !!permissions.find((p) => p.value === 'User.IsInAdminRole') ? 'admin' : 'user',
    props: {
      claims: permissions
        .filter((p) => !([ 'nonce', 'at_hash', 'sid', 'sub', 'bff:session_state' ].includes(p.type)))
        .map((p: UserClaim) => {
          return p.value;
        }),
    }
  });
}
Object.assign(window, {
  UserGuides: {
    initProductFruits,
  }
});
